import { STATUS } from "@/lib/api";
import { t } from "@/i18n";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status];
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-bold uppercase tracking-wide"
      style={{ background: `${s.color}22`, color: s.color, border: `1px solid ${s.color}66` }}
    >
      <span className="h-2 w-2 rounded-full nv-blink" style={{ background: s.color }} />
      {t(s.label)}
    </span>
  );
};
